String.prototype.replaceAll = String.prototype.replaceAll || function (search, replacement) {
    "use strict";
    var target = this;

    if (typeof search === 'string') {
        search = search.escapeRegex();
    }

    return target.replace(new RegExp(search, 'g'), replacement);
};